<template>
  <div id="doc-main" class="d-flex flex-column flex-lg-row-reverse justify-space-between" style="width: 100%">
    <div class="d-flex flex-column flex-md-row flex-wrap flex-lg-nowrap flex-lg-column mb-md-6 mx-auto px-lg-2 no-print" style="width: 100%" id="actions">
      <div class="mx-2">
        <v-select :items="documents" v-model="selectedDocument" item-value="value" item-text="name" outlined dense placeholder="Document type"></v-select>
      </div>
      <div class="mx-2">
        <v-select :items="sessions" v-model="selectedSession" return-object item-text="name" outlined dense placeholder="Session"></v-select>
      </div>
      <div class="mx-2">
        <v-select :items="semesters" v-model="selectedSemester" return-object item-text="title" outlined dense placeholder="Semester"></v-select>
      </div>
      <div class="mx-2">
        <v-btn color="primary" elevation="0" width="100%" :disabled="disablePrinting" :loading="printing" @click="printDoc">
          Print
        </v-btn>
      </div>
    </div>
    <div style="width: 80%" class="mx-md-auto pl-lg-8" v-if="!isMobile">
      <v-sheet id="doc" elevation="1" class="pa-4 d-flex flex-column" v-if="selectedDocument === 1" style="height: 297mm; width: 210mm /* size of A4 paper */">
        <div>
          <div class="d-flex flex-row justify-space-between">
            <!--   logo     -->
            <div>
              <v-img :src="logo" alt="lg" aspect-ratio="1" width="120px"></v-img>
            </div>
            <!--   text     -->
            <div class="my-auto">
              <div class="text-center basic--text font-weight-bold mb-6 text--uppercase">Student's Course Registration Form</div>
            </div>
            <!--   user's image     -->
            <div>
              <v-img aspect-ratio="1" style="border-radius: 10px; border: #7D9EB5 2px solid" width="120" :src="image"></v-img>
            </div>
          </div>

          <v-sheet outlined rounded class="mt-8 mx-auto">
            <v-simple-table dense>
              <tbody>
              <tr>
                <th style="width: 15%">Name</th>
                <td style="width: 35%">{{ user.name }}</td>
                <th style="width: 15%">Matric:</th>
                <td style="width: 30%">{{ user.userId }}</td>
              </tr>
              <tr>
                <th style="width: 15%" >Faculty</th>
                <td style="width: 35%" class="text-left">{{ user.programme.department.faculty.name }}</td>
                <th style="width: 15%" >Department:</th>
                <td style="width: 30%">{{ user.programme.department.name }}</td>
              </tr>
              <tr>
                <th style="width: 15%" >Programme</th>
                <td style="width: 35%" class="text-left">{{ user.programme.name }}</td>
                <th style="width: 15%" >Level</th>
                <td style="width: 30%">{{ user.level.title }}</td>
              </tr>
              <tr>
                <th style="width: 15%" >Session</th>
                <td style="width: 35%" class="text-left">{{selectedSession != null ? selectedSession.name : ''}}</td>
                <th style="width: 15%" >Date:</th>
                <td style="width: 30%">{{new Date().toLocaleString()}}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-sheet>
          <div class="d-flex flex-row justify-space-between basic--text mt-8 mb-3 subtitle-2 font-weight-bold">
            <div>Semester: {{ selectedSemester != null ? selectedSemester.title : '' }}</div>
            <div>Total Credit Load: {{creditLoad}}</div>
          </div>

          <v-sheet outlined rounded class="mx-auto">
            <v-simple-table dense>
              <thead>
              <tr>
                <th>Course</th>
                <th>Title</th>
                <th >Credit Load</th>
                <th class="text-right">Lecturer's Sign.</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in registeredCourses" :key="index">
                <td style="font-size: 0.8em" class="font-weight-bold">{{item.courseCode}}</td>
                <td style="font-size: 0.8em" class="">{{item.title}}</td>
                <td style="font-size: 0.8em" class=" ">{{item.creditUnit}}</td>
                <td></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-sheet>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex flex-row justify-space-between mb-12">
          <div class="d-flex flex-row"><div class="subtitle-2 font-weight-bold mt-auto">HOD's Signature: </div><div class="sigContainer"><img class="sigBg" id="sig" alt="sig" :src="hodSignature"></div></div>
          <div class="mt-auto"><span class="subtitle-2 font-weight-bold">Student's Signature: </span>__________________________</div>
        </div>
      </v-sheet>
      <v-sheet id="doc1" elevation="2" class="pa-4 d-flex flex-column" v-else style="height: 210mm; width: 148mm /* size of A5 paper */">
        <div style="width: 100%">
          <div class="d-flex flex-row justify-space-between">
            <!--   logo     -->
            <div>
              <v-img :src="logo" alt="lg" aspect-ratio="1" width="120px"></v-img>
            </div>
            <!--   text     -->
            <div class="my-auto">
              <div class="text-center basic--text font-weight-bold mb-6 text--uppercase">Student's Examination Card</div>
            </div>
            <!--   user's image     -->
            <div>
              <v-img aspect-ratio="1" style="border-radius: 10px; border: #7D9EB5 2px solid" width="120" :src="image"></v-img>
            </div>
          </div>

          <v-sheet outlined rounded class="mt-8 mx-auto">
            <v-simple-table dense>
              <tbody>
              <tr>
                <th style="width: 15%">Name</th>
                <td style="width: 35%">{{ user.name }}</td>
                <th style="width: 15%">Matric:</th>
                <td style="width: 30%">{{ user.userId }}</td>
              </tr>

              <tr>
                <th style="width: 15%" >Programme</th>
                <td style="width: 35%" class="text-left">{{ user.programme.name }}</td>
                <th style="width: 15%" >Level</th>
                <td style="width: 30%">{{ user.level.title }}</td>
              </tr>
              <tr>
                <th style="width: 15%" >Session</th>
                <td style="width: 35%" class="text-left">{{selectedSession != null ? selectedSession.name : ''}}</td>
                <th style="width: 15%" >Semester:</th>
                <td style="width: 30%">{{selectedSemester != null ? selectedSemester.title : ''}}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-sheet>
          <v-sheet outlined rounded class="mx-auto mt-4">
            <v-simple-table dense>
              <thead>
              <tr>
                <th>Course</th>
                <th>Title</th>
                <th >Credit Load</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in registeredCourses" :key="index">
                <td style="font-size: 0.8em" class="font-weight-bold">{{item.courseCode}}</td>
                <td style="font-size: 0.8em" class="">{{item.title}}</td>
                <td style="font-size: 0.8em" class=" ">{{item.creditUnit}}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-sheet>
          <v-spacer></v-spacer>
          <div class="d-flex flex-row-reverse justify-space-between basic--text mt-8 mb-3 subtitle-2 font-weight-bold">
            <div>Total Credit Load: {{creditLoad}}</div>
          </div>
        </div>
      </v-sheet>
    </div>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import Defaults from "@/shared/Defaults";
import Links from "@/shared/constants/Links";
export default {
  name: "CourseFormAndExamCard",
  components: {MessageBox, LoadingDialog},
  props: ['courses', 'user', 'sessions', 'semester'],
  data: () => ({
    semesters: [],
    selectedSemester: null,
    selectedSession: null,
    registeredCourses: [],
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    hodSignature: '',
    logo: Defaults.api + Links.global.logo,
    documents: [
      {
        name: 'Course form',
        value: 1
      },
      {
        name: 'Exam card',
        value: 2
      }
    ],

    selectedDocument: 1,
    image: '',
    printing: false,
  }),

  methods: {
    printDoc(){
      if (this.selectedDocument === 1){
        this.printing = true
        Api.downloads.courseForm(this.user.id, this.selectedSession.id, this.selectedSemester.id)
            .then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
              const link = document.createElement('a');
              link.href = url;
              let fileName = "cf" + this.selectedSession.id + '' +this.selectedSemester.id
              link.setAttribute(fileName, fileName+'.pdf'); //or any other extension
              document.body.appendChild(link);
              link.click();
            }).catch((err) => ErrorResolver.checkErrors(this, err))
            .finally(() => this.printing = false)
      } else{
        this.printing = true
        Api.downloads.examCard(this.user.id, this.selectedSession.id, this.selectedSemester.id)
            .then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
              const link = document.createElement('a');
              link.href = url;
              let fileName = 'ec'+ this.selectedSession.id + '' +this.selectedSemester.id
              link.setAttribute(fileName, fileName+'.pdf'); //or any other extension
              document.body.appendChild(link);
              link.click();
            }).catch(() => {
          this.message = "Failed to download content"
          this.messageType = "error"
          this.messageShow = true
        })
            .finally(() => this.printing = false)
      }
    },

    loadCourses(){
      if(this.selectedSemester != null && this.selectedSession != null){
        this.loading = true;
        this.registeredCourses = []
        let uId = this.user.userId
        let session = this.selectedSession.id
        let semester = this.selectedSemester.id
        Api.students.getRegisteredCoursesForSemester(uId, session, semester)
        .then(res => {
          this.registeredCourses = res.data
        }).catch(err => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
      }
    },

    loadData(){
      // get department's hod
      Api.department.getHod(this.user.programme.department.id)
      .then(res => {
        if(res.data != null){
          this.hodSignature = Defaults.api + '/signature/fetch/' + res.data.user.userId
        }
      }).catch(err => ErrorResolver.checkErrors(this, err))
    }
  },

  computed: {
    creditLoad: function(){
      return this.registeredCourses.map(e => e.creditUnit).reduce((p, c) => p + c, 0)
    },

    disablePrinting: function(){
      return this.selectedSemester == null || this.selectedSession == null
    },

    isMobile: function(){
      return this.$vuetify.breakpoint.smAndDown
    },

    isMedium: function(){
      return this.$vuetify.breakpoint.mdOnly
    },

    isMediumAndDown: function(){
      return this.$vuetify.breakpoint.mdAndDown
    },


    isMediumAndUp: function(){
      return this.$vuetify.breakpoint.mdAndUp
    },
  },

  watch: {
    selectedSession: function(newVal){
      if(newVal != null){
        this.semesters = newVal.semesters
        this.loadCourses()
      }
    },

    selectedSemester: function(){
      this.loadCourses()
    },

    courses: function(newV){
      this.registeredCourses = newV;
    },

    user: function(){
      if(this.user != null){
        // document.getElementById("sig").src = this.user.programme.department.hodSignature
        this.image = Defaults.api + '/profile-picture/fetch?user=' +  this.user.userId;
        this.loadData()
      }
    }
  },

  created() {
    this.registeredCourses = this.courses
    this.image = Defaults.api + '/profile-picture/fetch?user=' +  this.user.userId;
    if(this.user != null){
      this.loadData()
    }
  }

}
</script>

<style scoped>
@media print {
  #doc{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
  }

  #doc1{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 210mm;
    min-width: 148mm;
    z-index: 99999;
  }

  #actions{
    display: none;
    height: 0;
    width: 0;
  }

  .no-print{
    display: none;
  }

  @page {
    margin: 0;
    size: A5;
  }
}

.sigContainer{
  border-bottom: black 1px solid;
}

.sigBg{
  background-repeat: no-repeat;
  margin-bottom: -30px;
}
</style>
